module.exports = __webpack_public_path__ + "assets/img/file_icon.1cf66a64.png";